import { useEffect, useLayoutEffect, useRef } from 'react';

/** No timer is running. */
export const NO_TIMEOUT = null;

/**
 * Calls `callback` once, `delayMs` after the timer starts. `null` stops it.
 * The timer restarts whenever `delayMs` or `resetKey` changes, so a repeated
 * trigger (a new nonce) restarts a flash instead of cutting it short.
 */
export function useTimeout(callback: () => void, delayMs: number | null, resetKey?: unknown): void {
  const latest = useRef(callback);
  useLayoutEffect(() => {
    latest.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delayMs === NO_TIMEOUT) return undefined;
    const id = setTimeout(() => latest.current(), delayMs);
    return () => clearTimeout(id);
  }, [delayMs, resetKey]);
}
